import { Button, Link, Stack, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useState } from "react";
import CustomInputLogin from "../../utils/CustomInputLogin";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { signInFormSchema } from "./shema";
import { post } from "../../utils/request";
import { useNavigate } from "react-router-dom";

import { getLocalStorage } from "../../../stores/localStores";
import { isAxiosError } from "axios";

import { toast } from "react-hot-toast";
export const SignUpForm = ({ isBack = () => {} }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    handleSubmit,
    formState: { errors },

    setValue,
    clearErrors,
    reset,
    getValues,
  } = useForm({
    resolver: zodResolver(signInFormSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      await post({
        path: `/auth/sing-up`,
        data: {
          ...data,
          username_sponsor: !!getLocalStorage("sponsor")
            ? getLocalStorage("sponsor")
            : "genesis",
        },
      });
      reset();
      navigate("/");
      setLoading(false);
    } catch (error) {
      if (isAxiosError(error)) {
        const code = error.response?.status;
        const message = error.response?.data?.message;
        if (code === 404) {
          if (message === "El email ya se encuentra registrado") {
            toast.error("El email ya se encuentra registrado", {
              style: {
                backgroundColor: "black",
                fontWeight: "700",
                fontFamily: "Arial",
                color: "#fff",
                fontSize: "16px",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              },
            });
          }
          if (message === "El username ya se encuentra registrado") {
            toast.error("El username ya se encuentra registrado", {
              style: {
                backgroundColor: "black",
                fontWeight: "700",
                fontFamily: "Arial",
                color: "#fff",
                fontSize: "16px",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              },
            });
          }
        }
        if (code === 500) {
          console.log(message);
        }
      }
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <ArrowBack
        onClick={isBack}
        sx={{
          cursor: "pointer",
          color: "#a95052",
          "&:hover": { color: "#8c3e47" },
        }}
      />
      <Stack maxWidth={{ xs: "350px", md: "390px" }}>
        <Typography
          fontWeight={"500"}
          color="black"
          mb={2}
          textAlign={"left"}
          sx={{ fontSize: "1.06rem", lineHeight: "1.25rem", color: "#596173" }}
        >
          Crea tu cuenta para comenzar a invertir con Plusvalica
        </Typography>
        <Stack spacing={2}>
          <CustomInputLogin
            label="Nombre"
            disabled={loading}
            id="name"
            placeholder="Ingrese su Nombre"
            onChange={(e) => {
              setValue("name", e.target.value);
              clearErrors("name");
            }}
            value={getValues("name")}
            isError={errors.name}
            errorMsg={errors.name?.message}
          />
          <CustomInputLogin
            label="Apellido"
            disabled={loading}
            id="last_name"
            placeholder="Ingrese su Apellido"
            onChange={(e) => {
              setValue("last_name", e.target.value);
              clearErrors("last_name");
            }}
            value={getValues("last_name")}
            isError={errors.last_name}
            errorMsg={errors.last_name?.message}
          />
          <CustomInputLogin
            label="Username"
            disabled={loading}
            id="username"
            placeholder="Ingrese su nombre de usuario"
            onChange={(e) => {
              setValue("username", e.target.value);
              clearErrors("username");
            }}
            value={getValues("username")}
            isError={errors.username}
            errorMsg={errors.username?.message}
          />

          <CustomInputLogin
            label="Correo Electrónico"
            disabled={loading}
            id="email"
            placeholder="Ingrese su Correo electrónico"
            onChange={(e) => {
              setValue("email", e.target.value);
              clearErrors("email");
            }}
            value={getValues("email")}
            isError={errors.email}
            errorMsg={errors.email?.message}
          />

          <Button
            type="submit"
            disabled={loading}
            variant="contained"
            sx={{
              backgroundColor: "#a95052",
              "&:hover": { backgroundColor: "#8c3e47" },
            }}
          >
            Registrarse
          </Button>
        </Stack>{" "}
        <Typography
          fontWeight={"400"}
          color="black"
          mt={2}
          textAlign={"left"}
          sx={{ fontSize: "0.9rem", lineHeight: "1.25rem", color: "#596173" }}
        >
          Si ya tienes una cuenta, inicia sesión haciendo click{" "}
          <Link
            sx={{
              color: "#a95052",
              "&:hover": { color: "#8c3e47" },
              cursor: "pointer",
            }}
            onClick={() => {
              navigate("/sign-in");
            }}
          >
            aqui.
          </Link>
        </Typography>
      </Stack>
    </form>
  );
};
